import { createAction } from 'actions/utils';
import {
    GET_IMPLEMENTATIONS_REQUEST,
    GET_IMPLEMENTATIONS_SUCCESS,
    GET_IMPLEMENTATIONS_ERROR,
    GET_IMPLEMENTATION_DETAIL_REQUEST,
    GET_IMPLEMENTATION_DETAIL_SUCCESS,
    GET_IMPLEMENTATION_DETAIL_ERROR,
    CREATE_FAVORITE_SUCCESS,
    CREATE_FAVORITE_ERROR,
    REMOVE_FAVORITE_SUCCESS,
    REMOVE_FAVORITE_ERROR,
    GET_FAVORITES_REQUEST,
    GET_FAVORITES_SUCCESS,
    GET_FAVORITES_ERROR,
    GET_LICENSES_REQUEST,
    GET_LICENSES_SUCCESS,
    GET_LICENSES_ERROR,
    SET_IMPLEMENTATION_DETAIL_PARAMETER,
    SET_IMPLEMENTATION_DETAIL_TRAITS,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getImplementations(query, filter, license) {
    return (dispatch) => {
        if (query.length === 0 && license.length === 0) {
            dispatch(createAction(GET_IMPLEMENTATIONS_SUCCESS, []));
            return () => null;
        }
        dispatch(createAction(GET_IMPLEMENTATIONS_REQUEST, query));
        return Core.implementationManager.getImplementations(query, filter, license).then(
            (response) => dispatch(createAction(GET_IMPLEMENTATIONS_SUCCESS, response)),
            (error) => {
                dispatch(createAction(GET_IMPLEMENTATIONS_ERROR, error));
                throw error;
            },
        );
    };
}

export function getImplementationDetail() {
    return (dispatch) => {
        dispatch(createAction(GET_IMPLEMENTATION_DETAIL_REQUEST, null));
        return Core.implementationManager.getImplementationDetail().then(
            (response) => dispatch(createAction(GET_IMPLEMENTATION_DETAIL_SUCCESS, response)),
            (error) => {
                dispatch(createAction(GET_IMPLEMENTATION_DETAIL_ERROR, error));
                throw error;
            },
        );
    };
}

export function setImplementationDetailParameter(data) {
    return (dispatch) => dispatch(createAction(SET_IMPLEMENTATION_DETAIL_PARAMETER, data));
}

export function setImplementationDetailTraits(data) {
    return (dispatch) => dispatch(createAction(SET_IMPLEMENTATION_DETAIL_TRAITS, data));
}

export function setImplementationDetail(data) {
    return (dispatch) => dispatch(createAction(GET_IMPLEMENTATION_DETAIL_SUCCESS, data));
}

export function createFavorite(idImpl) {
    return (dispatch) =>
        Core.implementationManager.createFavorite(idImpl).then(
            (response) => {
                if (response.status === true) {
                    dispatch(createAction(CREATE_FAVORITE_SUCCESS, idImpl));
                } else {
                    dispatch(createAction(CREATE_FAVORITE_ERROR, idImpl));
                }
            },
            (error) => {
                dispatch(createAction(CREATE_FAVORITE_ERROR, idImpl));
                throw error;
            },
        );
}

export function removeFavorite(idImpl) {
    return (dispatch) =>
        Core.implementationManager.removeFavorite(idImpl).then(
            (response) => {
                if (response.status === true) {
                    dispatch(createAction(REMOVE_FAVORITE_SUCCESS, idImpl));
                } else {
                    dispatch(createAction(REMOVE_FAVORITE_ERROR, idImpl));
                }
            },
            (error) => {
                dispatch(createAction(REMOVE_FAVORITE_ERROR, idImpl));
                throw error;
            },
        );
}

export function getFavorites() {
    return (dispatch) => {
        dispatch(createAction(GET_FAVORITES_REQUEST, {}));
        return Core.implementationManager.getFavorites().then(
            (response) => dispatch(createAction(GET_FAVORITES_SUCCESS, response)),
            (error) => {
                dispatch(createAction(GET_FAVORITES_ERROR, error));
                throw error;
            },
        );
    };
}

export function getLicenses() {
    return (dispatch) => {
        dispatch(createAction(GET_LICENSES_REQUEST, {}));
        return Core.implementationManager.getLicenses().then(
            (response) => dispatch(createAction(GET_LICENSES_SUCCESS, response)),
            (error) => {
                dispatch(createAction(GET_LICENSES_ERROR, error));
                throw error;
            },
        );
    };
}
